import React from 'react';

import NextI18nProvider from 'next-translate/I18nProvider';
import useTranslation from 'next-translate/useTranslation';

import i18nConfig from '../locales/i18n.js';
import namespaces from '../locales/index';

type I18nProviderProps = {
  children: React.ReactNode;
};

export const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const { lang } = useTranslation();

  return (
    <NextI18nProvider config={i18nConfig} lang={lang} namespaces={namespaces}>
      {children}
    </NextI18nProvider>
  );
};
